import styles from "./style.module.scss";
import ForthSectionB2b from "@components/severalbrands/b2b/forthSection";
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Our Expertise",
        paragraphs: [
            "Our digital marketing solutions connect your B2B offerings with clients who are looking for them, using the strategies outlined below.",
            <>
                <h4 className="font-bold 3xl:text-3xl lg:text-xl 3xl:leading-[4rem] text-base lg:leading-10 text-[#351C4F]">
                    Search Engine Marketing (SEM):
                </h4>
                <p>
                    Our SEM strategies combine paid search and organic
                    techniques to maximize your visibility. By managing PPC
                    campaigns and optimizing landing pages, we drive high-intent
                    traffic to your B2B solutions, delivering real value for
                    your spend.
                </p>
            </>,
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        imgClassName:
            "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px]  lg:ml-16 3xl:ml-28",
    },

    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Search Engine Optimization (SEO):",
        paragraphs: [
            "Our SEO strategies help your B2B solutions rank well on search engines, so potential clients can find you. By targeting industry-specific keywords and optimizing our comparison and review sites, we drive organic traffic and visibility to your site.",
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: `${styles["mainTitleStyle"]} 3xl:mt-16`,
        imgToLeft: true,
        imgClassName:
            "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]   ",
    },

    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Content Marketing",
        paragraphs: [
            "We create informative content that addresses your target audience's actual pain points, building the trust and credibility that helps potential clients choose your solutions.",
            <>
                <h4 className="font-bold 3xl:text-3xl lg:text-xl 3xl:leading-[4rem] text-base lg:leading-10 text-[#351C4F] ">
                    Social Media Campaigns:
                </h4>
                <p>
                    Our social media strategies meet audiences on the platforms
                    where they already spend time, highlighting what makes your
                    B2B solutions worth choosing.
                </p>
            </>,
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        mainTitleClassName: styles["mainTitleStyle"],
        imgClassName:
            "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28  3xl:mt-8 lg:mt-5",
    },
    {
        img: "/severalbrands/assets/images/unlockingBusinessComponentImg4.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "Our display campaigns use data-driven targeting and strong creative to put your B2B solutions in front of the right audience, building recognition and driving conversions.",
            <>
                <h4 className="font-bold 3xl:text-3xl lg:text-xl 3xl:leading-[4rem] text-base lg:leading-10 text-[#351C4F] ">
                    Localization:
                </h4>
                <p>
                    We tailor your marketing to resonate with local markets,
                    adapting content and messaging to regional preferences so
                    you connect with clients across different geographies.
                </p>
            </>,
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28`,
        mainTitleClassName: styles["mainTitleStyle"],
        imgToLeft: true,
        imgClassName:
            "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]  lg:mt-20",
    },
];

const partnerWithUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: "At Several Brands, we're invested in your growth, not just handing off leads and moving on. Our team builds and adjusts campaigns around your KPIs, backed by lead validation that combines automated checks with human review, so what reaches you has already been screened. From lead generation to reporting, we handle the process so your team can focus on closing.",
            className: "default",
        },
    ],
    buttonText: "Talk to Our Sales Team",
};
export default function ForthSectionContainer() {
    return (
        <ForthSectionB2b
            mainData={{
                partnerWithUSData: partnerWithUSData,
                unlockBusinessContent: unlockBusinessContent,
            }}
        />
    );
}
